import React, { useState, useMemo } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import {
  STACK_CENTER,
  STACK_CENTER_COLUMN_DIRECTION,
  STACK_START_COLUMN_DIRECTION,
  STACK_START_ROW_DIRECTION,
} from '../../constants/mui-components';
import {
  ourSolutionsContainer,
  ourSolutionsContent,
  preheadingIconContainer,
  preheadingIcon,
  preheadingTypography,
  titleContainer,
  titleTypography,
  subtitleTypography,
  imageContainer,
  imageStyles,
  contentStack,
} from './styles/our-solutions.styles';
import { getCdnUrl } from '../../helpers';
import SingleExpandAccordion from '../../components/accordions';
import ourSolutionData from '../../constants/home/our-solutions';
import useGetCountry from '../../helpers/useGetCountry';
import { productsNotAvailableInMexico } from '../../constants/products/product-enum';

function OurSolutions() {
  const theme = useTheme();
  const [activePanel, setActivePanel] = useState('factoring');
  const country = useGetCountry();
  const countryAccordionsMapper = {
    Chile: ourSolutionData.accordionsInfo,
    Mexico: ourSolutionData.accordionsInfo.filter(
      (item) => !productsNotAvailableInMexico.includes(item.name.toLowerCase()),
    ),
  };

  const handlePanelChange = (panel) => {
    setActivePanel(panel);
  };

  const currentVideo = useMemo(() => {
    const items = countryAccordionsMapper[country];
    const activeItem = items.find((item) => item.name === activePanel);
    return activeItem ? activeItem.video : items[0].video;
  }, [activePanel, country]);

  return (
    <Stack
      className={STACK_CENTER_COLUMN_DIRECTION}
      sx={ourSolutionsContainer(theme)}
    >
      <Stack className={STACK_CENTER} gap="4rem">
        <Stack className={STACK_START_COLUMN_DIRECTION} sx={ourSolutionsContent}>
          <Stack className={STACK_START_ROW_DIRECTION} gap="0.25rem">
            <Box sx={preheadingIconContainer}>
              <CardMedia
                component="img"
                image={getCdnUrl(ourSolutionData.preheadingIcon)}
                alt="fingo_icon"
                style={preheadingIcon}
              />
            </Box>
            <Typography variant="medium_2" sx={preheadingTypography(theme)}>
              {ourSolutionData.preheading}
            </Typography>
          </Stack>
          <Stack className={STACK_START_COLUMN_DIRECTION} sx={titleContainer}>
            <Typography variant="xlarge_2" sx={titleTypography}>
              {ourSolutionData.titleText}
            </Typography>
            <Typography variant="medium_2" sx={subtitleTypography(theme)}>
              {ourSolutionData.subtitleText}
            </Typography>
          </Stack>
        </Stack>
        <Stack sx={contentStack}>
          <Box className={STACK_CENTER} sx={imageContainer(theme)}>
            <Box
              component="video"
              key={activePanel}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              sx={imageStyles}
            >
              <source src={getCdnUrl(currentVideo)} type="video/mp4" />
              <track kind="captions" src="" srcLang="es" label="Sin subtítulos" />
            </Box>
          </Box>
          <SingleExpandAccordion
            accordionsInfo={countryAccordionsMapper[country]}
            onPanelChange={handlePanelChange}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}

export default OurSolutions;
